import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppLifecycleService } from './app-lifecycle.service';

@Injectable()
export class WebAppLifecycleService extends AppLifecycleService {
  private active = signal(document.visibilityState === 'visible');
  private resumedSubject = new Subject<void>();

  readonly isActive = this.active.asReadonly();
  readonly resumed$: Observable<void> = this.resumedSubject.asObservable();

  init(): void {
    document.addEventListener('visibilitychange', () => {
      const isVisible = document.visibilityState === 'visible';
      const wasActive = this.active();
      this.active.set(isVisible);
      if (isVisible && !wasActive) {
        this.resumedSubject.next();
      }
    });
  }
}
